<mat-dialog-content>
  <mat-label>{{ data.energyElement.name }}</mat-label>
  @if (data.energyElement|transformValueByPredicateFunction:getInfoValuesPredicate; as infoValues) {
    <form [formGroup]="formGroup"
      >
      <div class="flex-between-center">
        @if (isEditable) {
          <button color="primary" mat-icon-button (click)="clickEdit()">
            <mat-icon>
              @if ((editEnabled$|async)) {
                clear
              } @else {
                edit
              }
            </mat-icon>
          </button>
        }
        <app-increment-field style="margin: 0 5px"
          formControlName="setPoint"
          [min]="0"
          [max]="30"
          [step]="5"
          >
        </app-increment-field>
      </div>
      <div class="selection-list-disabled-not-show-checkbox">
        <mat-selection-list formControlName="selectedSensors">
          @for (sensor of infoValues; track sensor) {
            <mat-list-option [value]="sensor.objectId">
              <div matListItemIcon style="width: 85px;" class="flex-between-center">
                <button mat-icon-button color="accent"
                  (click)="$event.stopPropagation();openInfoDevice(sensor)">
                  <mat-icon>info</mat-icon>
                </button>
                <button mat-icon-button color="primary"
                  (click)="$event.stopPropagation();openDialogChartSensorDataTypes(sensor)">
                  <mat-icon>insert_chart</mat-icon>
                </button>
              </div>
              <div matListItemTitle>{{ sensor.name }}</div>
            </mat-list-option>
          }
          <mat-divider></mat-divider>
        </mat-selection-list>
      </div>
    </form>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button color="accent" [mat-dialog-close]="undefined">
    <mat-icon>clear</mat-icon>
  </button>
  @if (isEditable) {
    @if ((editEnabled$|async)) {
      <button mat-flat-button color="primary" (click)="saveValue()"
        [disabled]="formGroup.invalid">
        <mat-icon>save</mat-icon>
      </button>
    }
  }
</mat-dialog-actions>